import { StoreAlertIcon } from './StoreAlertIcon';

/**
 * author: Colton Wiscombe
 * id 84CE3480-8C26-4B78-9524-CB8E6AA23F1D
 * name store-alert
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-alert.svg
 * tags
 * - Places 
 * - Shopping 
 * - Alert / Error 
 */
export const ShopAlertIcon = StoreAlertIcon;
export default ShopAlertIcon